export enum MediaAction {
  Direct = 'direct',
  Fetch = 'fetch',
  Copy = 'copy'
}
